import { render } from "./material.vue?vue&type=template&id=40f93f21"
import script from "./material.vue?vue&type=script&lang=js"
export * from "./material.vue?vue&type=script&lang=js"

import "./material.vue?vue&type=style&index=0&id=40f93f21&lang=css"

import exportComponent from "E:\\mydemo\\issue-security-vue\\issuebye-fore\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__